module.exports = __webpack_public_path__ + "img/116.ed80ab04.png";